<section class="paginate paginate-advanced">
    <div class="js-region-grid-viewing-details info"></div>
    <div class="navigate clearfix">
        <div class="js-region-grid-pagination-controls grid-pagination-controls"></div>
        <div class="js-region-grid-page-size-controls grid-page-size-controls"></div>
    </div>
</section>